if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {

		constructor(){

			super();

			const qty = this.querySelector('.qty-selector'),
						qtyMinus = this.querySelector('.qty-minus'),
						qtyPlus = this.querySelector('.qty-plus'),
						qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
						qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999,
						qtyStep = qty.getAttribute('step') ? parseInt(qty.getAttribute('step')) : 1;

			if ( parseInt(qty.value) - qtyStep < qtyMin ) {
				qtyMinus.classList.add('disabled');
			}
			if ( parseInt(qty.value) + qtyStep > qtyMax ) {
				qtyPlus.classList.add('disabled');
			}

			qty.addEventListener('change', (e)=>{
				let newQty = parseInt(qty.value);

				// Checks for invalid values and adjusts them:
				// - Values not matching our quantity step
				// - Values lower than minimum amount
				// - Values larger than maximum amount
				if (newQty % qtyStep != 0 || newQty > qtyMax || newQty < qtyMin) {
					newQty = Math.min(Math.max(qtyMin, Math.ceil(newQty / qtyStep) * qtyStep), qtyMax);
					qty.value = newQty;
					qty.dispatchEvent(new Event('change'));
					return;
				}

				const currentQty = parseInt(qty.value);
				if ( parseInt(qty.value) - qtyStep < qtyMin ) {
					qtyMinus.classList.add('disabled');
				} else {
					qtyMinus.classList.remove('disabled');
				}
				if ( parseInt(qty.value) + qtyStep > qtyMax ) {
					qtyPlus.classList.add('disabled');
				} else {
					qtyPlus.classList.remove('disabled');
				}
			});

			qtyMinus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( ! qtyMinus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
					if ( currentQty - qtyStep >= qtyMin ) {
						qty.value = currentQty - qtyStep;
						qty.dispatchEvent(new Event('change'));
						qtyPlus.classList.remove('disabled');
					} 
					if ( currentQty - qtyStep <= qtyMin ) {
						qtyMinus.classList.add('disabled');
					}
				}
			});

			qtyPlus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( ! qtyPlus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
					if ( currentQty + qtyStep <= qtyMax ) {
						qty.value = currentQty + qtyStep;
						qty.dispatchEvent(new Event('change'));
						qtyMinus.classList.remove('disabled');
					} 
					if ( currentQty + qtyStep >= qtyMax ) {
						qtyPlus.classList.add('disabled');
					}
				}
			});

		}
		
	}


  if ( typeof customElements.get('product-quantity') == 'undefined' ) {
    customElements.define('product-quantity', ProductQuantity);
	}

}